<template>
    <div>
        <div class="warpper">
            <div class="logo">
                <div>
                    <img src="~assets/image/plt-logo.png" alt />
                </div>
                <p>购物车</p>
            </div>
            <div v-if="productList.length">
                <ul class="productLists">
                    <li>
                        <Checkbox
                            style="margin-left: 12px"
                            :value="allCheck"
                            @on-change="allQuery($event, index)"
                            >全选</Checkbox
                        >
                    </li>
                    <li>商品信息</li>
                    <li>单价</li>
                    <li>数量</li>
                    <li>金额</li>
                    <li>操作</li>
                </ul>
                <ol>
                    <li
                        class="productItem"
                        v-for="(item, index) in productList"
                        :key="item.productId"
                    >
                        <ul>
                            <li class="queryProduct">
                                <div>
                                    <Checkbox
                                        :value="item.checked"
                                        @on-change="checkChange($event, index)"
                                    ></Checkbox>
                                </div>
                                <div class="imgs">
                                    <img :src="item.faceImage" alt />
                                </div>
                                <div class="productDesc">
                                    <h4>{{ item.productName }}</h4>
                                    <p>{{ item.productDesc }}</p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div
                                        v-for="config in item.config"
                                        :key="config"
                                    >
                                        {{
                                            `${config.configName}:${config.optionName}`
                                        }}
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div v-if="item.status == 'on'">
                                        <strong>￥{{ item.salePrice }}</strong>
                                    </div>
                                    <div v-else>已下架</div>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div class="inputText">
                                        <p
                                            @click="
                                                onQuantityMinus($event, index)
                                            "
                                            v-if="item.quantity > 1"
                                        >
                                            -
                                        </p>
                                        <div class="sky" v-else></div>
                                        <div>
                                            <input
                                                style="
                                                    height: 25px;
                                                    width: 61px;
                                                "
                                                type="number"
                                                @input="onIput($event, index)"
                                                max="99999"
                                                maxlength="5"
                                                v-model="item.quantity"
                                            />
                                        </div>
                                        <p
                                            @click="
                                                onQuantityChange($event, index)
                                            "
                                            v-if="item.quantity < 99999"
                                        >
                                            +
                                        </p>
                                        <div class="sky" v-else></div>
                                    </div>
                                    <p class="purchaseQty">
                                        <span>起购数：</span>
                                        <strong>{{
                                            item.minPurchaseQty
                                        }}</strong>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div>
                                        <strong
                                            >￥{{
                                                item.salePrice * item.quantity
                                            }}</strong
                                        >
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="discolor">
                                    <div
                                        @click="
                                            removeFromShoppingCart(
                                                item.shoppingCartId
                                            )
                                        "
                                    >
                                        删除
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ol>
                <div class="goPay">
                    <div>
                        <Checkbox
                            style="margin-left: 12px"
                            :value="allCheck"
                            @on-change="allQuery($event, index)"
                            >全选</Checkbox
                        >
                    </div>
                    <div>
                        <span class="discolor">删除</span>
                    </div>
                    <div>
                        <p>
                            已选商品
                            <strong
                                style="
                                    color: #ff9000;
                                    font-size: 20px;
                                    padding: 0 5px 0 5px;
                                "
                                >{{ totalQuantity }}</strong
                            >件
                        </p>
                    </div>
                    <div>
                        <p>
                            合计（不含运费）：
                            <strong
                                style="color: #ff9000; font-size: 20px"
                                v-if="totalPrice == '0'"
                                >{{ totalPrice }}:00</strong
                            >
                            <strong
                                style="color: #ff9000; font-size: 20px"
                                v-else
                                >￥{{ totalPrice }}</strong
                            >
                        </p>
                    </div>
                    <div @click="goPay">
                        <p :class="totalQuantity <= 0 ? 'backgroundGray' : ''">
                            结算
                        </p>
                    </div>
                </div>
            </div>
            <div v-else class="nullCart">
                <div>
                    <img src="~assets/image/cart.png" alt />
                </div>
                <ol class="descCart">
                    <li>购物车空空的哦~，去看看我们的托盘吧~</li>
                    <li>
                        <a href="javascript:;" @click="goProduct">去购物</a>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"shoppingCart",
    data() {
        return {
            productList: [],
            totalQuantity: 0,
            totalPrice: 0,
            allCheck: false
        };
    },
    created() {
        this.initShoppingCart();
    },
    mounted() {
    },
    methods: {
        // 购置数量
        onIput(event, index) {
            let obj = this.productList[index]
            if (obj.quantity.length > 5) {
                console.log(obj.quantity)
                obj.quantity = obj.quantity.slice(0, 5);
            }
        },
        goProduct() {
            this.$router.push('/mall')
        },
        initShoppingCart() {
            let data = {
                url: 'http://MID-CLIENT-MALL/messageService/shoppingCartService/queryShoppingCartList',
            }
            this.invoke(data).then(rs => {
                this.productList = rs;
                this.productList.forEach(ele => {
                    return ele.checked = false
                })
            })
        },
        async removeFromShoppingCart(shoppingCartId) {
            await this.showConfirm("操作提示", "将从购物车中移除?");

            let data = {
                url: 'http://MID-CLIENT-MALL/messageService/shoppingCartService/removeProductFromShoppingCart',
                body: { shoppingCartId }
            }

            this.invoke(data).then(() => {
                this.$Message.success("移除成功!");
                this.initShoppingCart();
            })
        },
        onQuantityChange(val, index) {

            this.productList[index].quantity = ++this.productList[index].quantity;
            this.calculatePrice();
        },
        onQuantityMinus(val, index) {

            this.productList[index].quantity = --this.productList[index].quantity;
            this.calculatePrice();
        },
        allQuery(val, index) {
            if (val) {
                this.productList.forEach(ele => {
                    ele.checked = true
                })
                this.allCheck = true
                this.$forceUpdate()
                this.calculatePrice();

            } else {
                this.productList.forEach(ele => {
                    ele.checked = false
                })
                this.allCheck = false
                this.totalQuantity = 0;
                this.totalPrice = 0
            }

        },
        checkChange(val, index) {

            this.productList[index].checked = val;
            let flag = this.productList.every(item => item.checked === true)
            if (flag) {
                this.allCheck = true
            } else {
                this.allCheck = false
            }
            this.calculatePrice();
        },
        calculatePrice() {
            let totalQuantity = 0;
            let totalPrice = 0;
            this.productList.map(({ quantity, salePrice, checked }) => {
                if (checked) {
                    totalQuantity += quantity;
                    totalPrice += (salePrice * quantity);
                }
            })
            this.totalQuantity = totalQuantity;
            this.totalPrice = totalPrice;
        },
        goPay() {
            if (this.totalQuantity < 1)
                this.errorPrompt('请选择要购买的商品');

            let checkedProductList = [];
            this.productList.map(({ minPurchaseQty, productId, productName, salePrice, quantity, config, checked, shoppingCartId, faceImage }) => {
                if (checked)
                    checkedProductList.push({ minPurchaseQty, productId, productName, productUnitPrice: salePrice, quantity, config, shoppingCartId, faceImage });
            })
            let flag = checkedProductList.every(item=>item.quantity >= item.minPurchaseQty);
            if(flag){
                this.$router.push({
                path: '/confirm-order',
                query: { productList: JSON.stringify(checkedProductList) }
            });
            }else{
                this.$Message.warning('购买数量不足起购数量')
            }

        }
    }
};
</script>

<style lang="less" scoped>
.warpper {
    margin: 0 auto;
    width: 1080px;
    .logo {
        width: 100%;
        margin: 30px 0 20px 0;
        border-bottom: 1px solid #e7e7e7;
        padding-bottom: 10px;
        display: flex;
        align-items: flex-end;
        div {
            width: 130px;
            height: 45px;
            img {
                width: 130px;
                height: 45px;
            }
        }
        p {
            margin-left: 10px;
            font-size: 25px;
            font-weight: bold;
        }
    }
    ul {
        width: 100%;
        display: flex;
        margin: 10px;
        li:nth-child(1) {
            width: 160px;
        }
        li:nth-child(2) {
            width: 450px;
        }
        li {
            width: 120px;
        }
    }
    ol {
        .productItem {
            width: 100%;
            height: 130px;
            background: #fcfcfc;
            border: 1px solid #e7e7e7;
            margin-bottom: 30px;
            ul {
                height: 100%;
                display: flex;
                .queryProduct {
                    width: 400px;
                    display: flex;
                    font-size: 14px;
                    div {
                        margin-left: 10px;
                    }
                    .imgs {
                        width: 82px;
                        height: 82px;
                        background: #fff;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid #eee;
                        img {
                            width: 80px;
                            // height: 80px;
                        }
                    }
                }
                li:nth-child(2) {
                    width: 200px;
                    color: #9c9c9c;
                }
                li:nth-child(3) {
                    width: 100px;
                }
                li:nth-child(4) {
                    width: 140px;
                    div {
                        .inputText {
                            display: flex;
                            // width: 77px;
                            width: 97px;
                            height: 25px;
                            background: #f0f0f0;
                            justify-content: center;
                            p {
                                width: 19px;
                                height: 25px;
                                line-height: 25px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                -webkit-user-select: none;
                                -moz-user-select: none;
                                -ms-user-select: none;
                                user-select: none;
                                &:hover {
                                    border: 1px solid #ff9000;
                                    cursor: pointer;
                                }
                            }
                            .sky {
                                width: 19px;
                            }
                            div {
                                input {
                                    // margin-left: 17px;

                                    // width: 41px;
                                    width: 61px;
                                    height: 25px;
                                    text-align: center;
                                    position: relative;
                                    z-index: 1;
                                    border: 1px solid #aaa;
                                    outline: none;
                                }
                                input::-webkit-outer-spin-button,
                                input::-webkit-inner-spin-button {
                                    -webkit-appearance: none;
                                }
                                input[type="number"] {
                                    -moz-appearance: textfield;
                                }
                            }
                        }
                        .purchaseQty {
                            margin-top: 5px;
                            span {
                                color: #9c9c9c;
                            }
                            strong {
                                color: #ff9000;
                            }
                        }
                    }
                }
                li:nth-child(5) {
                    color: #ff9000;
                }
                li:nth-child(3),
                li:nth-child(4),
                li:nth-child(5),
                li:nth-child(6) {
                    margin-top: 20px;
                }
            }
        }
    }
    .goPay {
        width: 100%;
        height: 50px;
        background: #e5e5e5;
        line-height: 50px;
        display: flex;
        div:nth-child(1) {
            // width: 120px;
            flex: 3;
        }
        div:nth-child(2) {
            flex: 20;
        }
        div:nth-child(3) {
            flex: 6;
        }
        div:nth-child(4) {
            flex: 9;
            p {
                margin-right: 5px;
            }
        }
        div:nth-child(5) {
            flex: 1;
            p {
                width: 120px;
                height: 50px;
                color: #fff;
                background: #ff9000;
                font-size: 20px;
                text-align: center;
                line-height: 50px;
                cursor: pointer;
            }
            .backgroundGray {
                background: #b0b0b0;
                cursor: no-drop;
            }
        }
    }
}
.nullCart {
    width: 100%;
    height: 100px;
    border: 1px dotted #ccc;
    display: flex;
    align-items: center;
    div {
        margin-left: 20px;
    }
    .descCart {
        margin-left: 40px;
        li {
            width: 300px;
            a {
                cursor: pointer;
                padding: 20px 0;
            }
        }
    }
}
</style>
